"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableStyle = exports.AddUserWrapper = exports.StyledForm = exports.ScrollableTableContainer = void 0;
const styles_1 = require("@mui/material/styles");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const formik_1 = require("formik");
exports.ScrollableTableContainer = (0, styles_1.styled)(TableContainer_1.default, {
    shouldForwardProp: (prop) => prop !== "shouldOverflowScroll",
})(({ shouldOverflowScroll }) => {
    return {
        maxHeight: "calc(100vh - 180px)",
        overflowY: shouldOverflowScroll ? "scroll" : "hidden",
    };
});
exports.StyledForm = (0, styles_1.styled)(formik_1.Form)({
    "&:not(:last-of-type)": {
        marginBottom: "60px",
    },
});
exports.AddUserWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
});
exports.tableStyle = { height: "fit-content" };
